import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-search",
  templateUrl: "./med-icon-search.component.html",
})
export class MedIconSearchComponent extends SvgMixinComponent {}
